export default __webpack_public_path__ + "static/media/gallery-5.5e590df8.jpg";